// import { useAppSelector } from 'hooks/redux';
import React, { useMemo, useState } from 'react';

// import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ControlPointDuplicateIcon from '@mui/icons-material/ControlPointDuplicate';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import ThreeDot from '@mui/icons-material/MoreVert';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import useTheme from '@mui/material/styles/useTheme';

import NestedQMenu from 'components/NestedQMenu';

// import ExcludeFromReports from 'assets/icons/settings-menu/ExcludeFromReports.inline.svg';
// import ExcludeFromSpendingPlan from 'assets/icons/settings-menu/ExcludeFromSpendingPlan.inline.svg';

// import { categoriesSelectors } from 'app-components/flux/categories';
// import { accountsSelectors } from 'app-components/flux/accounts';
// import { getTagsByIds } from 'app-components/flux/transaction-rules/transactionRulesSelectors';

import type {
  // CategorySourceConditionsType,
  TransactionRuleType,
  // AmountSourceConditionType,
  // UsageTypeSourceConditionsType,
} from 'app-components/flux/transaction-rules/transactionRulesTypes';

import Dump from 'components/Dump';
import { makeStyles } from 'tss-react/mui';
import CategoryTarget from './reviewConditions/CategoryTarget';
import { SourceHeading, TargetHeading } from './reviewConditions/Headings';
import PayeeSource from './reviewConditions/PayeeSource';
import PayeeTarget from './reviewConditions/PayeeTarget';

const useStyles = makeStyles()((theme) => ({
  background: {
    background: theme.palette.background.default,
  },
  row: {
    display: 'flex',
    flex: 1,
    flexWrap: 'wrap',
    '> *': {
      lineHeight: '24px',
    },

    '>.MuiBox-root+.MuiBox-root': {
      padding: `${theme.spacing(3)} ${theme.spacing(2)}`,
    },
    alignContent: 'flex-start',
    alignItems: 'center',
  },
  conditionsContainer: {
    display: 'flex',
    flexDirection: 'row',
    flex: 1,
    '> div+div': {
      borderLeft: `1px solid ${theme.palette.divider}`,
    },
  },
  column: {
    display: 'flex',
    flex: '0 0 50%',
    overflow: 'hidden',
    flexDirection: 'column',
    padding: `${theme.spacing(1.5)} ${theme.spacing(2)}`,
  },
  // textPaddingAfter: {
  //   paddingRight: theme.spacing(0.5),
  // },
  // highlightText: {
  //   color: theme.palette.info.main,
  // },
  // twoLines: {
  //   display: 'flex',
  //   flexFlow: 'row',
  //   flex: 1,
  //   '& > p': {
  //     flex: 'none',
  //   },
  //   '& > h6': {
  //     '-webkit-line-clamp': '2',
  //     '-webkit-box-orient': 'vertical',
  //     whiteSpace: 'nowrap',
  //     overflow: 'hidden',
  //     textOverflow: 'ellipsis',
  //   },
  // },
  columnRow: {
    display: 'flex',
  },
  threeDotMenu: {
    height: 24,
    color: theme.palette.icon.light,
    alignSelf: 'center',
    padding: 0,
    '&:hover': {
      cursor: 'pointer',
    },
  },
  columnMain: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    overflow: 'hidden',
  },
  threeDotArea: {
    display: 'flex',
    flex: 0,
  },
  rounded: {
    width: '100%',
    borderRadius: 20,
    border: `1px solid ${theme.palette.divider}`,
    '>*': {
      border: 'none',
    },
    '>:first-of-type': {
      borderTopRightRadius: 20,
      borderTopLeftRadius: 20,
    },
  },
}));

// interface RenderExcludeFromTargetConditionsProps {
//   id: string | undefined;
//   reports: boolean | undefined;
//   f2s: boolean | undefined;
// }

type RuleSummaryProps = {
  rule?: TransactionRuleType;
  onEditCallback?: (id: string) => void;
  onDeleteCallback?: (id: string) => void;
  onDuplicateCallback?: (id: string) => void;
  veritcalWithLabel?: boolean;
};

const RuleSummaryRow: React.FC<RuleSummaryProps> = ({
  rule,
  onEditCallback,
  onDeleteCallback,
  onDuplicateCallback,
  veritcalWithLabel,
}) => {
  const { classes, cx } = useStyles();
  const theme = useTheme();

  const [anchorEl, setAnchorEl] = useState(null);

  // TODO: All of the below needs to be moved out to respective components under /reviewConditions
  // const categoriesById = useSelector(categoriesSelectors.getCategoriesById);
  // const accountsById = useSelector(accountsSelectors.getAccountsById);
  // const tagsById = useAppSelector((state) => getTagsByIds(state, { tagIds: rule.tagsTargetIds || [] }));

  // const renderAmountSourceConditions = (amount: AmountSourceConditionType) => {
  //   const txnType = amount.amount1 < 0 ? 'Expense' : 'Income';
  //   return (
  //     <Box className={classes.row}>
  //       <Typography className={classes.textPaddingAfter} variant='bodyRegular'>
  //         Amount is
  //       </Typography>
  //       <Typography className={classes.textPaddingAfter} variant='bodyMedium'>
  //         {`an ${txnType} `}
  //         {amount.amountMatchingOperator.toLowerCase().replace('_', ' ')} ${Math.abs(amount.amount1)}
  //       </Typography>
  //       {amount.amountMatchingOperator === 'BETWEEN' && (
  //         <Typography variant='bodyMedium'> and ${Math.abs(amount.amount2)}</Typography>
  //       )}
  //     </Box>
  //   );
  // };

  // const renderAccountSourceIds = (accountIds: string[]) => {
  //   if (accountIds && accountIds.length > 0) {
  //     return (
  //       <>
  //         <Box className={classes.row}>
  //           <Typography className={classes.textPaddingAfter} variant='bodyRegular'>
  //             Account is
  //           </Typography>
  //           {accountIds.map((accountId, index, array) => {
  //             const accountName = accountsById.get(accountId)?.name;

  //             if (accountName) {
  //               return (
  //                 <>
  //                   <Typography key={accountId} className={classes.textPaddingAfter} variant='bodyMedium'>
  //                     {accountName}
  //                   </Typography>
  //                   {index + 1 < array.length && <Box className={classes.textPaddingAfter}>or</Box>}
  //                 </>
  //               );
  //             }

  //             return <></>; // TODO: should we highlight the fact that the account id was invalid?
  //           })}
  //         </Box>
  //       </>
  //     );
  //   }

  //   return <></>;
  // };

  // const renderCoaSourceConditions = (categories: CategorySourceConditionsType[]) => {
  //   if (categories && categories.length > 0) {
  //     return (
  //       <>
  //         <Box className={classes.row}>
  //           <Typography className={classes.textPaddingAfter} variant='bodyRegular'>
  //             Category is
  //           </Typography>
  //           {categories.map((category, index, array) => {
  //             const categoryName = categoriesById.get(category.id)?.name;

  //             if (categoryName) {
  //               return (
  //                 <>
  //                   <Typography key={category.id} className={classes.textPaddingAfter} variant='bodyMedium'>
  //                     {categoryName}
  //                   </Typography>
  //                   {index + 1 < array.length && <Box className={classes.textPaddingAfter}>or</Box>}
  //                 </>
  //               );
  //             }

  //             return <></>; // TODO: should we highlight the fact that the category id was invalid?
  //           })}
  //         </Box>
  //       </>
  //     );
  //   }

  //   return <></>;
  // };

  // const renderUsageSourceTypeConditions = (usageType: UsageTypeSourceConditionsType) => {
  //   return (
  //     <>
  //       <Box className={classes.row}>
  //         <Typography className={classes.textPaddingAfter} variant='bodyRegular'>
  //           Usage Type is
  //         </Typography>
  //         <Typography className={classes.textPaddingAfter} variant='bodyMedium'>
  //           {usageType}
  //         </Typography>
  //       </Box>
  //     </>
  //   );
  // };

  // const renderTagsTargetConditions = (tagIds: string[]) => {
  //   if (tagIds && tagIds.length > 0) {
  //     return (
  //       <>
  //         <Box className={classes.row}>
  //           <Typography className={classes.textPaddingAfter} variant='bodyRegular'>
  //             Update Tag(s) to
  //           </Typography>
  //           {tagIds.map((tagId, index, array) => {
  //             const tagName = tagsById.get(tagId)?.name;

  //             if (tagName) {
  //               return (
  //                 <>
  //                   <Typography key={tagName} className={classes.highlightText} variant='bodyMedium'>
  //                     {tagName}
  //                   </Typography>
  //                   {index + 1 < array.length && <Box className={classes.textPaddingAfter}>,</Box>}
  //                 </>
  //               );
  //             }

  //             return <></>; // TODO: should we highlight the fact that the category id was invalid?
  //           })}
  //         </Box>
  //       </>
  //     );
  //   }

  //   return <></>;
  // };

  // const renderNotesTargetConditions = (memoTarget: string) => {
  //   return (
  //     <>
  //       <Box className={cx(classes.row, classes.twoLines)}>
  //         <Typography className={classes.textPaddingAfter} variant='bodyRegular'>
  //           Update Notes to
  //         </Typography>
  //         <Typography className={cx(classes.textPaddingAfter, classes.highlightText)} variant='bodyMedium'>
  //           {memoTarget}
  //         </Typography>
  //       </Box>
  //     </>
  //   );
  // };

  // const renderReviewedTargetCondition = (reviewedTarget: boolean) => {
  //   const reviewedValue = reviewedTarget ? 'Reviewed' : 'Not Reviewed';
  //   return (
  //     <>
  //       <Box sx={{ alignItems: 'center' }} className={classes.row}>
  //         <Typography className={classes.textPaddingAfter} variant='bodyRegular'>
  //           Mark as
  //         </Typography>
  //         {reviewedTarget && (
  //           <Typography className={cx(classes.textPaddingAfter, classes.highlightText)} variant='bodyMedium'>
  //             {reviewedValue}
  //           </Typography>
  //         )}
  //         <CheckCircleIcon sx={{ height: 18, width: 18 }} color='success'></CheckCircleIcon>
  //       </Box>
  //     </>
  //   );
  // };

  // const renderExcludeFromTargetConditions = ({ id, reports, f2s }: RenderExcludeFromTargetConditionsProps) => {
  //   return (
  //     <>
  //       <Box className={classes.row}>
  //         <Typography className={classes.textPaddingAfter} variant='bodyRegular'>
  //           Exclude from
  //         </Typography>
  //         {reports && (
  //           <Typography className={cx(classes.textPaddingAfter, classes.highlightText)} variant='bodyMedium'>
  //             Reports
  //           </Typography>
  //         )}
  //         {reports && f2s && (
  //           <Typography className={classes.textPaddingAfter} variant='bodyRegular'>
  //             &
  //           </Typography>
  //         )}
  //         {f2s && (
  //           <Typography className={cx(classes.textPaddingAfter, classes.highlightText)} variant='bodyMedium'>
  //             Free to Spend
  //           </Typography>
  //         )}
  //         <Box className={classes.imgRoundedBackground}>
  //           {Boolean(f2s) && (
  //             <ExcludeFromSpendingPlan
  //               className={cx(classes.imgClass, !(Boolean(f2s) && Boolean(reports)) ? 'singleIcon' : '')}
  //               id={`${id}-ignored-spending-plan-label`}
  //             />
  //           )}
  //           {Boolean(reports) && (
  //             <ExcludeFromReports
  //               className={cx(classes.imgClass, !(Boolean(f2s) && Boolean(reports)) ? 'singleIcon' : '')}
  //               id={`${id}-ignored-reports-label`}
  //             />
  //           )}
  //         </Box>
  //       </Box>
  //     </>
  //   );
  // };

  const menuOptions = useMemo(() => {
    const options = [];
    if (rule) {
      if (onEditCallback) {
        options.push({
          id: 'edit-rule',
          label: 'Edit',
          startIcon: <EditIcon />,
          onSelect: () => {
            setAnchorEl(null);
            rule.id && onEditCallback(rule.id);
          },
        });
      }
      if (onDuplicateCallback) {
        options.push({
          id: 'duplicate-rule',
          label: 'Duplicate',
          startIcon: <ControlPointDuplicateIcon />,
          onSelect: () => {
            setAnchorEl(null);
            rule.id && onDuplicateCallback(rule.id);
          },
        });
      }
      if (onDeleteCallback) {
        options.push({
          id: 'delete-rule',
          label: 'Delete',
          onSelect: () => {
            setAnchorEl(null);
            rule.id && onDeleteCallback(rule.id);
          },
          customRender: (
            <Typography
              variant='bodyRegular'
              style={{ color: theme.palette.error.main, display: 'flex', alignItems: 'center' }}
            >
              <DeleteIcon style={{ marginRight: theme.spacing(1) }} />
              Delete
            </Typography>
          ),
        });
      }
    }
    return options;
  }, [theme, rule, onEditCallback, onDuplicateCallback, onDeleteCallback]);

  return (
    <>
      <NestedQMenu
        id='txn-rules-three-dot-menu'
        key={`three-dot`}
        anchorEl={anchorEl}
        onClose={() => {
          setAnchorEl(null);
        }}
        open={Boolean(anchorEl)}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        options={menuOptions}
      />
      {rule && (
        <Box
          className={cx(
            veritcalWithLabel ? (classes.column, classes.rounded) : (classes.row, classes.conditionsContainer),
          )}
        >
          <Dump obj={rule} />
          {veritcalWithLabel && <SourceHeading className={cx(veritcalWithLabel ? classes.background : '')} />}
          <Box className={classes.column}>
            <PayeeSource payee={rule.payeeSourceCondition} />
            {/* Add future Source Conditions here */}
          </Box>

          {veritcalWithLabel && <TargetHeading className={cx(veritcalWithLabel ? classes.background : '')} />}
          <Box className={classes.column}>
            <Box className={classes.columnRow}>
              <Box className={classes.columnMain}>
                <PayeeTarget payeeTarget={rule.payeeTarget} />
                <CategoryTarget
                  coaTarget={rule.coaTargetCondition}
                  businessCoaTarget={rule.businessCoaTargetCondition}
                  useDefaultAccount={!!rule.useDefaultAccountUsage}
                />
                {/* Add future Target Conditions here */}
              </Box>

              <Box className={classes.threeDotArea}>
                {menuOptions.length > 0 && (
                  <IconButton
                    id='rules-list-three-dot-menu'
                    className={classes.threeDotMenu}
                    aria-label='three-dot-menu'
                    onClick={(e: any) => {
                      e.stopPropagation();
                      setAnchorEl(e.currentTarget);
                    }}
                  >
                    <ThreeDot />
                  </IconButton>
                )}
              </Box>
            </Box>
          </Box>
        </Box>
      )}
    </>
  );
};

export default RuleSummaryRow;
